module.exports = __webpack_public_path__ + "mg.bc0aaf02fd22e03fe43c.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/node_modules/flag-icon-css/flags/4x3/mg.svg
// module id = ../../../../flag-icon-css/flags/4x3/mg.svg
// module chunks = styles